import { canUseDOM } from '@ps/web-core-utils';
// eslint-disable-next-line no-restricted-imports
import { useEffect, useLayoutEffect } from 'react';

const useIsomorphicLayoutEffect = canUseDOM ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
